import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { UserState, SetUserRolePayload, SetPlatformIdPayload } from "./userTypes";

const initialState: UserState = {
  role: "TB_GENERAL_READONLY",
  platformId: null,
  isAuthSyncComplete: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserRole: (state, action: PayloadAction<SetUserRolePayload>) => {
      state.role = action.payload.role;
    },
    setPlatformId: (state, action: PayloadAction<SetPlatformIdPayload>) => {
      state.platformId = action.payload.platformId;
    },
    setAuthSyncComplete: (state) => {
      state.isAuthSyncComplete = true;
    },
  },
});

export const { setUserRole, setPlatformId, setAuthSyncComplete } = userSlice.actions;
export const userReducer = userSlice.reducer;
